if (!customElements.get('swatch-selector')) {
  customElements.define('swatch-selector', class SwatchSelector extends HTMLElement {
    constructor() {
      super()

      setTimeout(() => {
        const addBtn = this.querySelector('.swatch-selector-btn:not(.sold-out)')
        if (!addBtn) return

        addBtn.addEventListener('click', async () => {
          if (!this.hasAllSwatchSelected()) {
            this.querySelector('.warning-text').style.display = 'block'
            return
          } else {
            this.querySelector('.warning-text').style.display = 'none'
          }

          const addToCart = (items) => {
            if (!addBtn.classList.contains('loading')) {
              addBtn.classList.add('loading')
            }

            if (addBtn.getAttribute('data-confetti') === 'true') {
              triggerConfetti(addBtn)
            }

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({ items }),
            })
              .then(() => {
                fetchCart()
                addBtn.classList.remove('loading')
              })
              .catch(() => {
                addBtn.classList.remove('loading')
                alert('Error adding to cart. Please try again.')
              })
          }

          const swatch = this.querySelector('swatch-selector-swatch')

          if (swatch) {
            const selectedOptionValueIds = Array.from(
              swatch.querySelectorAll('.swatch-custom-image.swatch-selected')
            ).map(item => item.getAttribute('data-option-value-id')).filter(id => id)

            if (selectedOptionValueIds.length > 0) {
              const handle = this.getAttribute('data-handle')

              addBtn.classList.add('loading')
              fetch(`/products/${handle}?option_values=${selectedOptionValueIds.join(',')}&section_id=product-variants`)
                .then(response => response.text())
                .then(html => {
                  const parser = new DOMParser()
                  const doc = parser.parseFromString(html, 'text/html')
                  const variantIdInput = doc.querySelector('#product-variants-id')

                  if (variantIdInput && variantIdInput.value) {
                    addToCart([{
                      id: parseInt(variantIdInput.value),
                      quantity: 1,
                    }])
                  } else {
                    addBtn.classList.remove('loading')
                    alert('Unable to find variant. Please try again.')
                  }
                })
                .catch(() => {
                  addBtn.classList.remove('loading')
                  alert('Error adding to cart. Please try again.')
                })
            } else {
              const dataId = addBtn.getAttribute('data-id')
              if (dataId) {
                addToCart([{
                  id: parseInt(dataId),
                  quantity: 1,
                }])
              }
            }
          } else {
            const dataId = addBtn.getAttribute('data-id')
            if (dataId) {
              addToCart([{
                id: parseInt(dataId),
                quantity: 1,
              }])
            }
          }
        })
      }, 20)
    }

    hasAllSwatchSelected() {
      const swatch = this.querySelector('swatch-selector-swatch')

      if (!swatch) {
        return true
      }

      const totalOptions = swatch.querySelectorAll('.swatch-single').length
      const selectedOptions = swatch.querySelectorAll('.swatch-custom-image.swatch-selected').length

      return selectedOptions === totalOptions && totalOptions > 0
    }
  })
}

if (!customElements.get('swatch-selector-swatch')) {
  customElements.define('swatch-selector-swatch', class SwatchSelectorSwatch extends HTMLElement {
    constructor() {
      super()

      setTimeout(() => {
        const optionGroups = this.querySelectorAll('.swatch-single')

        optionGroups.forEach((optionGroup, groupIndex) => {
          const swatchesInGroup = optionGroup.querySelectorAll('.swatch-custom-image')
          const variantNameDisplay = optionGroup.querySelector('.swatch-variant-name')

          swatchesInGroup.forEach(item => item.addEventListener('click', () => {
            swatchesInGroup.forEach(swatch => swatch.classList.remove('swatch-selected'))

            const target = item
            target.classList.add('swatch-selected')

            if (variantNameDisplay) {
              variantNameDisplay.innerHTML = target.getAttribute('data-value')
            }

            this.checkSoldOutState()

            this.setAttribute(`data-selected-option${groupIndex + 1}`, target.getAttribute('data-value'))
          }))
        })

        this.checkSoldOutState()
      }, 50)
    }

    checkSoldOutState() {
      const selector = this.closest('swatch-selector')
      if (!selector) return

      const hasSoldOut = this.querySelector('.swatch-custom-image.swatch-selected.sold-out')

      const bisTrigger = document.querySelector('#BIS_trigger')
      if (bisTrigger) {
        bisTrigger.style.display = hasSoldOut ? 'flex' : 'none'
      }

      const addBtn = selector.querySelector('.swatch-selector-btn:not(.sold-out)')
      const soldOutBtn = selector.querySelector('.swatch-selector-btn.sold-out')

      if (hasSoldOut) {
        selector.querySelector('.warning-text').style.display = 'none'
        if (addBtn) addBtn.style.display = 'none'
        if (soldOutBtn) soldOutBtn.style.display = 'flex'
      } else {
        if (addBtn) addBtn.style.display = 'flex'
        if (soldOutBtn) soldOutBtn.style.display = 'none'
      }
    }
  })
}
